import { useEffect } from "react";

const SITE_NAME = "Innovators Prep";
const DEFAULT_DESCRIPTION =
  "Innovators Prep is a warm, inclusive early childhood education centre in Brooklyn, NY offering 2K, 3K, Pre-K, and 4410 Preschool Special Education programs. Play. Learn. Grow.";

function setMeta(selector, attr, content) {
  const tag = document.head.querySelector(selector);
  if (tag) tag.setAttribute(attr, content);
}

/**
 * Per-page SEO — sets the browser tab title and meta/OG/social descriptions.
 * Usage: <SEO title="About" description="..." />
 */
export default function SEO({ title, description = DEFAULT_DESCRIPTION }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Play. Learn. Grow.`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [title, description]);

  return null;
}
